// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const ampharos_mega: PokeData = {
  "id": 10045,
  "name": "ampharos-mega",
  "height": 14,
  "weight": 615,
  "base_experience": 275,
  "types": [
    PokeType.ELECTRIC,
    PokeType.DRAGON
  ],
  "api_moves": [
    "fire-punch",
    "thunder-punch",
    "tackle",
    "take-down",
    "growl",
    "thunder-shock",
    "thunder-wave",
    "thunder",
    "confuse-ray",
    "light-screen",
    "cotton-spore",
    "zap-cannon",
    "charge",
    "signal-beam",
    "dragon-pulse",
    "power-gem",
    "discharge",
    "electro-ball",
    "cotton-guard",
    "ion-deluge",
    "magnetic-flux"
  ],
  "moves": [
    "fire-punch",
    "thunder-punch",
    "tackle",
    "growl",
    "thunder-shock",
    "thunder",
    "confuse-ray",
    "zap-cannon",
    "dragon-pulse",
    "electric-wrath",
    "dragon-fang",
    "draco-meteor",
    "volt-crash"
  ],
  "evolution_chain": {
    "id": 89,
    "item": null,
    "species": [
      {
        "name": "mareep",
        "order": 208,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "flaaffy",
        "order": 209,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": 179,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 15,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "ampharos",
        "order": 210,
        "types": [
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": 180,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 30,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 128,
    "speed": 58,
    "ability_power": 214
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": true,
  "is_gmax": false,
  "regional_variant": null
} as const;
